/* =============================================
   X-WEAR: VARIANT METAFIELDS — UNIFIED SCRIPT
   Single DOMContentLoaded — no race conditions
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── SHARED REFERENCES ─────────────────── */
  var variantSelector = document.querySelector('[name="id"]');

  /* ─── FRAME / LENS COLOR ────────────────── */
  var metafieldDisplay = {
    manufacturerCode: document.getElementById('manufacturer-code'),
    frameColor:       document.getElementById('frame-color'),
    lensColor:        document.getElementById('lens-color'),
  };
  var metafieldContainers = {
    manufacturerCodeContainer: document.getElementById('manufacturer-code-container'),
    frameColorContainer:       document.getElementById('frame-color-container'),
    lensColorContainer:        document.getElementById('lens-color-container'),
  };
  var metafieldsDisplay = document.getElementById('metafields-display');

  function processMetafields(variantElement) {
    var manufacturerCode = variantElement.dataset.manufacturerCode || '';
    var frameColor       = variantElement.dataset.frameColor || '';
    var lensColor        = variantElement.dataset.lensColor || '';

    function setField(display, container, value) {
      if (!display || !container) return;
      if (value) {
        display.textContent = value;
        container.style.display = 'flex';
      } else {
        container.style.display = 'none';
      }
    }

    setField(metafieldDisplay.manufacturerCode, metafieldContainers.manufacturerCodeContainer, manufacturerCode);
    setField(metafieldDisplay.frameColor,        metafieldContainers.frameColorContainer,        frameColor);
    setField(metafieldDisplay.lensColor,         metafieldContainers.lensColorContainer,         lensColor);

    if (metafieldsDisplay) {
      metafieldsDisplay.style.display =
        (frameColor || lensColor || manufacturerCode) ? 'inline-flex' : 'none';
    }
  }

  function updateMetafields(variantId) {
    var el = document.querySelector(
      '.variant-metafields[data-variant-id="' + variantId + '"]'
    );
    if (el) {
      processMetafields(el);
    } else {
      setTimeout(function () {
        var retryEl = document.querySelector(
          '.variant-metafields[data-variant-id="' + variantId + '"]'
        );
        if (retryEl) processMetafields(retryEl);
      }, 300);
    }
  }

  /* ─── SPECIFICATIONS FETCH ───────────────── */
  var specsEl = document.getElementById('xw-fulldesc-specs');
  var currentFetchId = 0;

  function updateSpecs(variantId) {
    if (!specsEl) return;
    specsEl.style.opacity = '0.4';
    var thisFetchId = ++currentFetchId;

    var url = window.location.pathname
      + '?variant=' + variantId
      + '&_=' + Date.now();

    fetch(url, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache'
      }
    })
    .then(function (res) {
      if (!res.ok) throw new Error('fetch failed');
      return res.text();
    })
    .then(function (html) {
      if (thisFetchId !== currentFetchId) return;
      var parser  = new DOMParser();
      var doc     = parser.parseFromString(html, 'text/html');
      var newSpec = doc.getElementById('xw-fulldesc-specs');
      if (newSpec) {
        specsEl.innerHTML = newSpec.innerHTML;
        specsEl.style.display = '';
      } else {
        specsEl.style.display = 'none';
      }
      specsEl.style.opacity = '1';
    })
    .catch(function () {
      setTimeout(function () {
        if (thisFetchId !== currentFetchId) return;
        fetch(window.location.pathname + '?variant=' + variantId + '&_=' + Date.now(), {
          cache: 'no-store'
        })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');
          var newSpec = doc.getElementById('xw-fulldesc-specs');
          if (newSpec) {
            specsEl.innerHTML = newSpec.innerHTML;
            specsEl.style.display = '';
          } else {
            specsEl.style.display = 'none';
          }
          specsEl.style.opacity = '1';
        })
        .catch(function () {
          specsEl.style.opacity = '1';
        });
      }, 600);
    });
  }

  /* ─── STICKY ATC ─────────────────────────── */
  var stickyBar   = document.getElementById('xw-sticky-atc');
  var stickyBtn   = document.getElementById('xw-sticky-btn');
  var stickyPrice = document.getElementById('xw-sticky-price');
  var mainAtc     = document.querySelector('.product-form__submit');

  if (stickyBar && stickyBtn && mainAtc) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainAtc);

    function updateStickyPrice(variantId) {
      if (!stickyPrice) return;
      try {
        var productVariants = window.__xwVariants;
        if (!productVariants) return;
        var matched = productVariants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (matched) {
          stickyPrice.textContent = (matched.price / 100).toLocaleString('en-US', {
            style: 'currency', currency: 'USD'
          });
          var stickyVariant = document.getElementById('xw-sticky-variant');
          if (stickyVariant && matched.title) {
            stickyVariant.textContent = matched.title;
          }
        }
      } catch (e) {}
    }

    if (variantSelector) {
      variantSelector.addEventListener('change', function () {
        updateStickyPrice(this.value);
      });
    }

    document.addEventListener('xw:variantChange', function (e) {
      if (e.detail && e.detail.variantId) {
        updateStickyPrice(e.detail.variantId);
      }
    });

    stickyBtn.addEventListener('click', function () {
      var variantId = variantSelector ? variantSelector.value : null;
      if (!variantId) return;
      var btn = this;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = 'Added!';
        var cartCount = document.querySelector('.cart-count-bubble');
        if (cartCount) {
          var countEl = cartCount.querySelector('[aria-hidden]');
          if (countEl) countEl.textContent = (parseInt(countEl.textContent) || 0) + 1;
          cartCount.style.display = '';
        }
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = 'Add to cart';
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Add to cart';
      });
    });
  }

  /* ─── UNIFIED INIT ───────────────────────── */
  function initAll(variantId) {
    if (!variantId) return;
    updateMetafields(variantId);
    setTimeout(function () { updateSpecs(variantId); }, 100);
  }

  /* Variant selector change */
  if (variantSelector) {
    variantSelector.addEventListener('change', function () {
      setTimeout(function () {
        initAll(variantSelector.value);
      }, 400);
    });
    /* Initial load */
    setTimeout(function () {
      initAll(variantSelector.value);
    }, 400);
  }

  /* Thumbnail click */
  document.addEventListener('xw:variantChange', function (e) {
    if (e.detail && e.detail.variantId) {
      setTimeout(function () {
        initAll(e.detail.variantId);
      }, 400);
    }
  });

  /* ─── BFCACHE FIX ────────────────────────── */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setTimeout(function () {
        if (variantSelector) initAll(variantSelector.value);
      }, 300);
    }
  });

  window.addEventListener('load', function () {
    setTimeout(function () {
      if (variantSelector) initAll(variantSelector.value);
    }, 600);
  });

});